module.exports = __webpack_public_path__ + "static/img/team.8b6b1a99.png";